export function mergeDefined<T extends object>(defaults: T, overrides?: Partial<T>): T {
  return {
    ...defaults,
    ...Object.fromEntries(
      Object.entries(overrides ?? {}).filter(([, v]) => v !== undefined)
    )
  }
}
